import SoftBox from "components/SoftBox";
import useAllowEditWorkflow from "hooks/useAllowEditWorkflow";
import { useDetermineShareFlowUserAccessType } from "hooks/useDetermineShareFlowUserAccessType";
import { ComponentPropsContextApi } from "layouts/Flow Designer/context";
import { ComponentPropsContext } from "layouts/Flow Designer/context";
import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { styles } from "../..";
import { removeNonIntegerCharsAndAcceptContext } from "helpers/common";
import { useDebouncer } from "hooks/useDebouncer";
import AutocompleteInput from "../AutocompleteInput";
import { NODE_TYPES } from "constants/flowDesigner";
import { combineStyles } from "helpers/common";

export const TextInput = ({ action, getFieldValue }) => {
  const { actionForm } = useContext(ComponentPropsContext);
  const { setActionForm, setFormErrors } = useContext(ComponentPropsContextApi);
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";
  const { allowEditWorkflow } = useAllowEditWorkflow();
  const { isReadOnlyAccess } = useDetermineShareFlowUserAccessType(currentSavedFlow?.id);
  const { selectedNode } = useSelector((store) => store?.designer?.componentPropsPanel);
  const [firstValue, setFirstValue] = useState(getFieldValue(action));
  const { debouncer: inputDebouncer } = useDebouncer(handleFormInputChange);

  const handleSetFirstValue = (event, val) => {
    let value = val ? val : event.target?.value;

    if (action.field === "delayAmount") {
      value = removeNonIntegerCharsAndAcceptContext(value);
    }

    setFirstValue(value);
    inputDebouncer(event);
  };

  function handleFormInputChange() {
    const key = action.field;
    let actionFormCopy = { ...actionForm };

    setFormErrors((prev) => prev.filter((error) => error !== key));

    if (actionFormCopy[key]?.isPassword) {
      actionFormCopy[key] = {
        ...actionFormCopy[key],
        value: firstValue,
        isPassword: true,
        isEncoded: false
      };
    }

    if (key === "serverUrl" && actionFormCopy.oauthConnectionId?.value) {
      delete actionFormCopy.oauthConnectionId;
    }

    setActionForm({
      ...actionFormCopy,
      [key]: { ...actionFormCopy[key], value: firstValue, isVariable: false }
    });
  }

  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      width="100%"
      sx={combineStyles(styles.w100, styles.listItemMargin_t16)}
    >
      <AutocompleteInput
        action={action}
        fieldValue={firstValue}
        onChange={handleSetFirstValue}
        disabled={isFlowActive || !allowEditWorkflow(isReadOnlyAccess)}
        isBranchInput={selectedNode.type === NODE_TYPES.LABEL}
        noValidate
      />
    </SoftBox>
  );
};
